import React from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { RemediationValidationAdminRow } from '../../interfaces/questionnaire.interface';

const VerificationActionsCell = ({ row, handleActionClick }: {
  row: RemediationValidationAdminRow,
  handleActionClick: (row: RemediationValidationAdminRow) => void;
}) => {
  const subControlsToVerify = row.remediationQuestionAnswers.filter(
    (item) => item.remediationPlan === 'remediated',
  ).length;

  const subControlsVerified = row.remediationQuestionAnswers.filter((item) => {
    const isVerified = item.verificationStatus !== 'not_started';
    const hasVerificationDate = !!item.verificationDate;
    const hasVerificationComment = !!item.verificationComment;
    return isVerified && hasVerificationDate && hasVerificationComment;
  });

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleStart = () => {
    handleMenuClose();
    handleActionClick(row);
  };

  return (
      <>
        <IconButton size="small" onClick={handleMenuOpen}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={handleStart}>
            {subControlsToVerify > 0 && subControlsVerified.length === 0
              ? 'Start Verification'
              : 'Continue Verification'}
          </MenuItem>
        </Menu>
      </>
  );
};

export default VerificationActionsCell;
  